import React from 'react';
import PropTypes from 'prop-types';
import { useAvatar } from '../../hooks/useAvatar';
import { useTranslation } from 'react-i18next';
import { DivAvatar, Img, Upload, InputFile } from './styled';
import { Form } from 'react-bootstrap';
import { mediaAvatar } from '../../constants/files';
import imgAvatar from '../../assets/images/profile/avatar.png';
import imgEdit from '../../assets/images/profile/edit.png';
import { Required } from '../shared/Input/styled';

/**
 * Avatar component with structure, image, upload and icon for Profile
 * @component
 * @param {String} margin
 * @param {Boolean} help
 * @param {string} customImgWidth          - String, including px, such as '150px'
 * @param {string} customImgWidthXs        - String, including px, such as '100px'
 * @param {string} customBgColor           - Either color name or hex value
 * @param {string} customJustifyContentXs  - New value for justify content, on xs size.
 * @param {string} customMarginTopXs       - String for margin top on mobile, including the unit (such as 'px').


 * @returns
 */
export const Avatar = ({ 
    margin = '100px', 
    help = false,
    customImgWidth = '',
    customImgWidthXs='',
    customBgColor = '',
    customJustifyContentXs = 'flex-start',
    customMarginTopXs = ''
  }) => {
  const { t } = useTranslation();
  const { srcAvatarImage, avatarSize, onChange, localSrcAvatarImage } = useAvatar();

  const upload = () => {
    let input = document.getElementsByName('btn_upload_img')[0]
    if (input) input?.click()
  }

  const [profileImg, setProfileImg] = React.useState(srcAvatarImage || localSrcAvatarImage || imgAvatar)
  const onError = () => {
    setProfileImg(localSrcAvatarImage || imgAvatar)
  }

  return (
    <>
      <DivAvatar 
        style={{ marginTop: margin }} 
        customJustifyContentXs={customJustifyContentXs}
        customMarginTopXs={customMarginTopXs}
      >
        <Img
          data-image="image-avatar"
          src={profileImg}
          onError={onError}
          customImgWidth={customImgWidth}
        />
        <Upload             
          onClick={upload}
          customBgColor={customBgColor}
        >
          <InputFile
            accept={ mediaAvatar }
            onChange={ onChange }
            name="btn_upload_img"
          />
          <img
            alt="Edit Avatar"
            className="img-avatar"
            src={ imgEdit }
          />
        </Upload>
      </DivAvatar>
      {help && (
        <Form.Text muted>
          <Required className="text-danger">&nbsp;*&nbsp;</Required>
          {t ("profile.avatarSize", { size: avatarSize }) }
        </Form.Text>
      )}
    </>
  );
};

Avatar.propTypes = {
  margin: PropTypes.string.isRequired,
  help: PropTypes.bool
};
